// eslint-disable-next-line @eslint-community/eslint-comments/disable-enable-pair
/* eslint-disable camelcase */

'use client';

import classnames from 'classnames/bind';
import { memo, useCallback, useEffect, useRef } from 'react';
import {
  EAnalytics,
  ENumberOfCalls,
  WATCH_OF_INTERSECTING_DELAY_TWO_SECONDS,
} from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { EBlockName, ESlideId } from '@/_components/promo-zone/_types';
import { watchOfIntersecting } from '@/_utils/watch-of-intersecting';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'SlideObserver';

type TProps = {
  blockName: EBlockName;
  slideId: ESlideId;
  isIntersectingSlider?: boolean;
};

export const SlideObserver = memo(function SlideObserverComponent({
  blockName,
  slideId,
  isIntersectingSlider,
}: TProps) {
  const intersectionTargetRef = useRef<HTMLDivElement | null>(null);
  const isObserve = useRef(false);
  const sendEvent = useAnalytics();

  const handleUnobserveCallback = useCallback(() => {
    isObserve.current = false;
  }, []);

  useEffect(() => {
    if (isObserve.current) return;

    const sendAnalytics = ({ duration }: { duration: number }): void => {
      const config = {
        name: EAnalytics.SUPPLIER_LANDING_PROMO_SUBBLOCK_V,
        params: {
          duration,
          name_block: blockName,
          name_subblock: slideId,
        },
      };

      sendEvent(config);
    };

    if (!isObserve.current) {
      watchOfIntersecting({
        element: intersectionTargetRef.current,
        callback: sendAnalytics,
        delay: WATCH_OF_INTERSECTING_DELAY_TWO_SECONDS,
        numberOfCalls: ENumberOfCalls.ONCE,
        unobserveCallback: handleUnobserveCallback,
      });

      isObserve.current = true;
    }
  }, [
    blockName,
    sendEvent,
    slideId,
    isIntersectingSlider,
    handleUnobserveCallback,
  ]);

  return <div ref={intersectionTargetRef} className={cn(BLOCK_NAME)} />;
});
